import type { KudoContentObjectList } from 'models';
import { useMemo } from 'react';
import { createExpressingKudoOption } from '../../expressing-kudo';
import { createCommunityOption } from '../../utils';
import type { KudoFormValues } from '../KudoForm';

export const useGetInitialValues = (kudoContentObject?: KudoContentObjectList): Partial<KudoFormValues> =>
  useMemo(() => {
    const [community] = kudoContentObject?.postInCommunities ?? [];

    return {
      attachments: { files: kudoContentObject?.attachments ?? [], loading: false },
      community: community ? createCommunityOption(community) : undefined,
      htmlContent: kudoContentObject?.kudo.htmlContent ?? '',
      pinned: kudoContentObject?.pinned ?? false,
      textContent: kudoContentObject?.kudo.textContent,
      user: kudoContentObject ? createExpressingKudoOption(kudoContentObject.kudo.user) : undefined,
    };
  }, [kudoContentObject]);
